"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenApiGeneratedClient = void 0;
const CoreApiClient_1 = require("./CoreApiClient");
class OpenApiGeneratedClient extends CoreApiClient_1.CoreApiClient {
    constructor(config) {
        super(config);
        this.configurationParameters = (config === null || config === void 0 ? void 0 : config.configurationParameters) || {};
        const configParamsCastAsAny = this.configurationParameters;
        configParamsCastAsAny.basePath = this.config.baseURL;
        if (this.config.auth) {
            configParamsCastAsAny.baseOptions = Object.assign(Object.assign({}, configParamsCastAsAny.baseOptions), { auth: this.config.auth });
        }
        if (configParamsCastAsAny.username) {
            throw new Error("OpenApiGeneratedClient: `username` is not allowed in the configuration parameters. Use `BasicAuthConfigSupport.basicAuthUser` instead.");
        }
        if (configParamsCastAsAny.password) {
            throw new Error("OpenApiGeneratedClient: `password` is not allowed in the configuration parameters. Use `BasicAuthConfigSupport.basicAuthPassword` instead.");
        }
        this.openApiGeneratedApi = this.instantiateOpenApiGeneratedApi();
        this.afterAxiosInitialized(this.openApiGeneratedApi.axios);
    }
    getConfigurationParameters() {
        return this.configurationParameters;
    }
    getOpenApiGeneratedApi() {
        return this.openApiGeneratedApi;
    }
}
exports.OpenApiGeneratedClient = OpenApiGeneratedClient;
//# sourceMappingURL=OpenApiGeneratedClient.js.map